<template>
    <validation-provider :rules="rules" :name="name" v-bind="$attrs" v-slot="{errors, valid, invalid, validated}">
        <b-form-group>
            <slot name="label">
                <label v-if="addLabelSpace" :class="labelClasses">
                    &nbsp;&nbsp;&nbsp;&nbsp;
                </label>
            </slot>
            <div :class="[
       {'input-group': hasIcon},
       {'focused': focused},
       {'input-group-alternative': alternative},
       {'has-label': label || $slots.label},
       inputGroupClasses
       ]">
                <div v-if="prependIcon || $slots.prepend" class="input-group-prepend">
                    <slot name="prepend">
                        <span class="input-group-text">
                            <i :class="prependIcon"></i>
                        </span>
                    </slot>
                </div>
                <slot v-bind="slotData">
                    <base-checkbox
                        v-on="listeners"
                        v-bind="$attrs"

                        :checked="value"
                        type="checkbox"
                        :required="required"
                        :valid="validated ? valid : null"
                        :input-classes="inputClasses"
                        inline
                        :class="[
                            {'is-valid': valid && validated && successMessage},
                            {'is-invalid': invalid && validated},
                        ]">
                        {{ label }}
                    </base-checkbox>

                </slot>
                <div v-if="appendIcon || $slots.append" class="input-group-append">
                    <slot name="append">
                        <span class="input-group-text">
                            <i :class="appendIcon"></i>
                        </span>
                    </slot>
                </div>
                <slot name="infoBlock"></slot>
            </div>
            <transition :name="animation" appear>
                <slot name="success">
                    <div class="valid-feedback" v-if="valid && validated && successMessage">
                        {{ successMessage }}
                    </div>
                </slot>
                <slot name="error" :errors="errors">
                    <div v-if="errors[0]" class="invalid-feedback" style="display: block;">
                        {{ errors[0] }}
                    </div>
                </slot>
            </transition>
        </b-form-group>
    </validation-provider>
</template>
<script>

import ValidatedFieldMixin from './ValidatedFieldMixin';

export default {
    inheritAttrs: false,
    name: 'validated-checkbox',
    mixins: [ValidatedFieldMixin],
    props: {
        type: {
            type: String,
            description: 'Input type',
            default: 'text'
        },
        addLabelSpace: {
            type: Boolean,
            description: 'Adds a blank label for alignment.',
            default: false
        }
    },
    methods: {
        updateValue (value) {
            this.$emit('input', value);
        }
    }
};
</script>
<style></style>
